import React, { useState } from 'react'
import { Societe } from "../../../types/Societe"
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient"

type Props = {
    societes: Societe[]
    callback: () => void
}

type AutobizConfig = {
    IDPlaque: number
    autobiz_username: string | null
    autobiz_password: string | null
}

export default function ModalConfigAutobiz(props: Props) {
    const backofficeApiClient = new BackOfficeAPIClient()

    const [ hiddenPasswords, setHiddenPasswords ] = useState<Record<number, boolean>>({})
    const [ isSubmitting, setIsSubmitting ] = useState<boolean>(false)

    const [ edits, setEdits ] = useState<AutobizConfig[]>([])

    const updateEdit = (societe: Societe, field: 'autobiz_username' | 'autobiz_password', value: string) => {
        setEdits(prev => {
            const existing = prev.find(e => e.IDPlaque === societe.IDPlaque)
            if (existing) {
                return prev.map(e =>
                    e.IDPlaque === societe.IDPlaque ? { ...e, [field]: value } : e,
                )
            }
            return [
                ...prev,
                {
                    IDPlaque: societe.IDPlaque,
                    autobiz_username: field === 'autobiz_username' ? value : (societe.autobiz_username ?? ''),
                    autobiz_password: field === 'autobiz_password' ? value : (societe.autobiz_password ?? ''),
                },
            ]
        })
    }

    const togglePassword = (id: number) => {
        setHiddenPasswords(prev => ({ ...prev, [id]: !prev[id] }))
    }

    const submitConfigAutobiz = async (e: any) => {
        e.preventDefault()
        setIsSubmitting(true)
        try {
            await backofficeApiClient.put<any>("/societes/configAutobiz", edits)
            document.getElementById('closeButtonConfigAutobizModal')?.click()
            props.callback()
        } catch (error) {
            console.log(error)
            throw error
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div data-backdrop="static" className="modal fade" id="modalConfigAutobiz" role="dialog" aria-labelledby="modalConfigAutobizLabel" aria-hidden="true">
            <form id="autobizConfig" onSubmit={submitConfigAutobiz} className={"tw-h-full"}>
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="createModalLabel">Configuration Autobiz</h5>
                            <button onClick={() => setEdits([])} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="card-body p-2">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Société</th>
                                        <th scope="col">Username</th>
                                        <th scope="col">Password</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {props.societes.map((societe) => {
                                        const isVisible = hiddenPasswords[societe.IDPlaque] === true
                                        const editedRow = edits.find(e => e.IDPlaque === societe.IDPlaque)
                                        return (
                                            <tr key={societe.IDPlaque}>
                                                <td>{societe.IDPlaque}</td>
                                                <td>{societe.Libelle}</td>
                                                <td>
                                                    <div className={"tw-flex tw-flex-row tw-items-center"}>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type={"text"}
                                                            value={editedRow?.autobiz_username ?? societe.autobiz_username ?? ''}
                                                            onChange={e => updateEdit(societe, 'autobiz_username', e.target.value)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={"tw-flex tw-flex-row tw-items-center"}>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type={isVisible ? "text" : "password"}
                                                            value={editedRow?.autobiz_password ?? societe.autobiz_password ?? ''}
                                                            onChange={e => updateEdit(societe, 'autobiz_password', e.target.value)}
                                                        />
                                                        <i
                                                            onClick={() => togglePassword(societe.IDPlaque)}
                                                            role="button"
                                                            className={"fa-solid p-2 " + (isVisible ? " fa-eye-slash" : " fa-eye")}
                                                            style={{
                                                                color: "darkgray",
                                                                cursor: "pointer",
                                                            }}>
                                                        </i>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => setEdits([])} id="closeButtonConfigAutobizModal" type="button" className="btn btn-secondary" data-dismiss="modal">Annuler
                            </button>
                            <button disabled={isSubmitting} type="submit" className="btn btn-primary">
                                {isSubmitting ? <i className="fa fa-spinner fa-spin tw-mr-2"/> : "Sauvegarder"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    )
}